<ng-container
              *ngIf="{
  filteredDiners: diners$ | async
} as vm">
  <ion-header>
    <ion-toolbar mode="md" color="dark">
      <ion-title>
        <ng-container>{{ 'dining.selectResidentAccountForGuestBilling' | transloco }}</ng-container>
      </ion-title>
      <ion-buttons slot="end">
        <ion-button mode="md"
                    (click)="onCloseModal()">{{ 'common.close' | transloco }}
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content fullscreen>
    <div>
      <div class="select-resident__filter">
        <ion-input
                   [autoFocusWithCondition]="true"
                   [placeholder]="'dining.searchResident' | transloco"
                   min="2"
                   minlength="2"
                   debounce="500"
                   clearInput="true"
                   [value]="searchQuery"
                   (ionChange)="searchingDiners($event)"></ion-input>
        <small class="ion-text-start">{{ 'dining.minimumCharactersRequiredSearch' | transloco: { count: 3 } }}</small>
      </div>
      <ion-list
                class="select-resident__list"
                *ngIf="!isSearchingDiner && vm.filteredDiners as diners">
        <ng-container *ngFor="let diner of diners; index as index">
          <ion-item
                    class="select-resident__resident">
            <ion-avatar slot="start">
              <pos-avatar-control [value]="diner.photo"></pos-avatar-control>
            </ion-avatar>
            <ion-label class="select-resident__resident__information">
              <h2><strong>{{ diner.first_name }} {{ diner.last_name }}</strong></h2>
              <span><strong>{{ 'dining.id' | transloco }}</strong> {{ diner.client_id }}</span>
              <span *ngIf="diner.type === 'resident'; else dinerInformation"><strong>{{ 'dining.liveLocation' |
                  transloco }}</strong>
                {{ diner.live_location }}</span>
              <ng-template #dinerInformation>
                <span><strong>{{ 'dining.category' | transloco }}</strong> {{ diner.diner_category_name }}</span>
              </ng-template>
            </ion-label>
            <ion-button mode="md"
                        color="dark"
                        debounce-click
                        [debounceTime]="0"
                        (debounceClick)="onResidentSelected(diner)">{{ 'common.use' | transloco }}
            </ion-button>
          </ion-item>
        </ng-container>
        <ion-item *ngIf="searchQuery?.length > 2 && !diners?.length"
                  lines="none">
          <p>{{ 'dining.noDinersMatchCriteria' | transloco }}</p>
        </ion-item>
      </ion-list>
      <ion-list *ngIf="isSearchingDiner"
                class="table-list__items">
        <pos-diner-assignment-skeleton></pos-diner-assignment-skeleton>
      </ion-list>
    </div>
  </ion-content>
  <ion-footer>
  </ion-footer>
</ng-container>